/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import ReproductionSubtype from "./components/forms/reproduction/reproductionSubtype.vue";
import ReproductionPriceForm from "./components/forms/reproduction/reproductionPriceForm.vue";
import ReproductionQuality from "./components/forms/reproduction/reproductionQuality.vue";
import ReproductionConstruction from "./components/forms/reproduction/reproductionConstruction.vue";
import ReproductionHelpModal from "./components/forms/reproduction/reproductionHelpModal.vue";

require('../bootstrap');
require('../plugins');

import copyToClipboard from "./components/copyToClipboard";
import faq from "./components/faq";
import openingHours from "./components/openingHours";
import spinner from "./components/spinner";
import stickyItem from "./components/stickyItem";
import scrollableX from "./components/scrollableX";
import PhonePicker from "./components/PhonePicker.vue";
import resizeText from "./components/resizeText";

copyToClipboard.init();

window.Vue = require('vue');

import ValuoForm from './components/valuo-form/form-wrapper.vue';
import ValuoSubmit from './components/valuo-form/form-post.vue';
import ValuoCustomArea from './components/valuo-form/form-custom-area.vue';
import ValuoStepCalculation from './components/valuo-form/steps/step-calculation.vue';
import ValuoStepPlace from './components/valuo-form/steps/step-place.vue';
import ValuoStepCondition from './components/valuo-form/steps/step-condition.vue';
import ValuoStepFloor from './components/valuo-form/steps/step-floor.vue';
import ValuoStepMore from './components/valuo-form/steps/step-more.vue';
import ValuoStepParameters from './components/valuo-form/steps/step-parameters.vue';
import ValuoStepType from './components/valuo-form/steps/step-type.vue';
import ValuoStepMotivation from './components/valuo-form/steps/step-motivation.vue';
import ValuoStepDate from './components/valuo-form/steps/step-date.vue';
import Coefficients from './components/coefficients.vue';
import EstateThumbnails from './components/estate-thumbs.vue';
import ThumbnailsAdverts from './components/partials/thumbnails-adverts.vue';
import CustomAutocomplete from './components/custom-autocomplete';
import AutosaveInput from './components/autosave-input';
import RecordSearch from './components/record-search';
import StatusChecker from './components/cuzk/status-checker';
import FilterForm from "./components/forms/cadastre/prices/FilterForm.vue";
import FileUpload from "./components/file-upload.vue";
import FileDelete from "./components/file-delete.vue";
import InstagramPosts from "./components/instagramPosts.vue";
import AsyncBlock from "./components/async-block.vue";
import Constants from "./components/includes/constants.vue";

import swiper from 'swiper/swiper-bundle';
window.swiper = swiper;

import tinymce from 'tinymce';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'datatables.net-bs4';
import 'datatables.net-responsive-bs4';
import select2 from 'select2';

import './methods';

// TODO - Uncomment after new Dashboard and new Graphs for exports are implemented
import Chart from 'chart.js/auto';
window.Chart = Chart;

window.tinymce = tinymce;
tinymce.init({
    selector: '.tinymce',
    plugins: "code link",
    theme_url: '/vendor/js/tinymce/themes/silver/theme.min.js',
    icons_url: '/vendor/js/tinymce/icons/default/icons.min.js',
    skin_url: '/vendor/css/tinymce/skins/ui/oxide',
    content_css: '/vendor/css/tinymce/skins/content/default/content.min.css',

    init_instance_callback: function (editor) {
        editor.on('blur', function (e) {
            //checkIfEmpty('#' + e.target.settings.id);
        });

        const max = 30;
        editor.on('keyup', function (e) {
            var targetElm = $($(this)[0].targetElm);
            if (!targetElm.hasClass('js-no-limit')) {
                var length = editor.contentDocument.body.innerText.length;
                targetElm.data('fail', false)
                if (length > max) {
                    tinymce.activeEditor.windowManager.alert(`Váš text je moc dlouhý (${length} znaků). Maximální délka je ${max} znaků. Upravte ho prosím.`);
                    targetElm.data('fail', true)
                    return false;
                }
            }
        });
    }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('valuo-form', ValuoForm);
Vue.component('valuo-submit', ValuoSubmit);
Vue.component('valuo-custom-area', ValuoCustomArea);
Vue.component('valuo-form-step-motivation', ValuoStepMotivation);
Vue.component('valuo-form-step-calculation', ValuoStepCalculation);
Vue.component('valuo-form-step-address', ValuoStepPlace);
Vue.component('valuo-form-step-condition', ValuoStepCondition);
Vue.component('valuo-form-step-floor', ValuoStepFloor);
Vue.component('valuo-form-step-more', ValuoStepMore);
Vue.component('valuo-form-step-parameters', ValuoStepParameters);
Vue.component('valuo-form-step-type', ValuoStepType);
Vue.component('valuo-form-step-motivation', ValuoStepMotivation);
Vue.component('valuo-form-step-date', ValuoStepDate);
Vue.component('coefficients', Coefficients);
Vue.component('estate-thumbnails', EstateThumbnails);
Vue.component('thumbnails-adverts', ThumbnailsAdverts);
Vue.component('custom-autocomplete', CustomAutocomplete);
Vue.component('autosave-input', AutosaveInput);
Vue.component('record-search', RecordSearch);
Vue.component('status-checker', StatusChecker);
Vue.component('reproduction-subtype', ReproductionSubtype);
Vue.component('reproduction-price-form', ReproductionPriceForm);
Vue.component('reproduction-help-modal', ReproductionHelpModal);
Vue.component('reproduction-quality', ReproductionQuality);
Vue.component('reproduction-construction', ReproductionConstruction);
Vue.component('filter-form', FilterForm);
Vue.component('file-upload', FileUpload);
Vue.component('file-delete', FileDelete);
Vue.component('phone-picker', PhonePicker);
Vue.component('instagram-posts', InstagramPosts);
Vue.component('async-block', AsyncBlock);
Vue.use(Constants);


/**
 * Import with Vue.js translations i18n init
 */
import i18n from './lang.js'

Vue.mixin({
    methods: {
        showSelectToMaxWidth: function (width) {
            const mediaQuery = window.matchMedia('(max-width: ' + width + 'px)');
            this.showSelect = mediaQuery.matches;
            mediaQuery.addListener((mq) => {
                this.showSelect = mq.matches;
            });
        }
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    i18n
});

$(function() {
    $('*[data-table="true"]').DataTable({
        paging: false,
        info: false,
        searching: false,
        columnDefs: [{
            targets: [-1],
            orderable: false
        }]
    }).columns(-3).order('desc').draw();

    $('.candidate .candidate-choice .rounded-white-btn, .candidate .candidate-choice .btn-primary, .candidate .candidate-choice .rounded-red-btn').on('click', function () {
        let candidate = $($(this).data('candidate'))
        let checkbox = $(this).data('checkbox')

        candidate.toggleClass('active')
        if (candidate.hasClass('active')) {
            candidate.addClass(checkbox == 'chosen_candidates[]' ? 'match' : 'not-match')
        } else {
            candidate.removeClass(checkbox == 'chosen_candidates[]' ? 'match' : 'not-match')
        }
        candidate.find('input[type="checkbox"][name="' + checkbox + '"]').click()
    });

    $(document).on('click', function (e) {
        let target = $(e.target)
        if (target.hasClass('candidate-scroll')) {
            $('#free-price-info').animate({
                scrollTop: $(target.data('target')).position().top
            }, 1000);
        } else if (target.hasClass('js-child-press')) {
            target.find('input').click()
        }
    });

    let infoToggle = document.querySelector('.js-info-toggle');
    if ((typeof(infoToggle) !== 'undefined') && (infoToggle !== null)) {
        infoToggle.addEventListener("click", function () {
            setTimeout(function () {
                let elmnt = document.getElementById("collapseHelp");
                elmnt.scrollIntoView();
            }, 100);
        });
    }
});

faq();
openingHours();
spinner();
stickyItem();
scrollableX();
resizeText();




